import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'company-photo-id-form',
  templateUrl: './company-photo-id-form.component.html',
  styleUrls: ['./company-photo-id-form.component.scss'],
})
export class CompanyPhotoIdFormComponent {
  @Input() public photoIdUri: string;
  @Input() public companyId: number;
  @Input() public isLoading: boolean = false;
  @Input() public isNonImageDocument: boolean = false;
  @Input() public fileName: string = '';
  @Output() public uploadPhotoIdSource$: EventEmitter<File> = new EventEmitter<File>();

  constructor() {}

  public uploadPhotoId(file: File): void {
    this.uploadPhotoIdSource$.emit(file);
  }
}
